export const IMPPERSONALGOALAction = {
    AddPersonalGoal: "ADDPERSONALGOAL",
    RemovePersonalGoal: "REMOVEPERSONALGOAL",
}

   const udpatedPerosonalGoals = [];

   const ImportPersonalGoalsReducer = (updtGoals = udpatedPerosonalGoals, actions) => {
       switch (actions.type) {
           case IMPPERSONALGOALAction.AddPersonalGoal:
             //  return { ...updtGoals, ...actions.payload };
             updtGoals.push(actions.payload);
             return updtGoals;
           case IMPPERSONALGOALAction.RemovePersonalGoal:
             updtGoals =[];
             return updtGoals;

            default:
                    return updtGoals;
       }
    }
    export default ImportPersonalGoalsReducer;